/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Automatic_Save_No_Records_PromptInputs */



/**
* | output |
* | --- |
* | "Please reload records to start" |
*
* @param {Automatic_Save_No_Records_PromptInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const automatic_save_no_records_prompt = /** @type {((inputs?: Automatic_Save_No_Records_PromptInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Automatic_Save_No_Records_PromptInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Veuillez recharger les enregistrements pour commencer")
	if (locale === "de") return /** @type {LocalizedString} */ ("Bitte laden Sie die Datensätze neu, um zu beginnen.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Ricarica i record per iniziare")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Пожалуйста, обновите записи, чтобы начать.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Por favor recargue los registros para comenzar")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("请重新加载记录以开始")
	if (locale === "ja") return /** @type {LocalizedString} */ ("開始するにはレコードを再読み込みしてください")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कृपया रिकॉर्ड पुनः लोड करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Por favor, recarregue os registros para começar.")
	return /** @type {LocalizedString} */ ("Please reload records to start")
});